import { render } from "./Partner.vue?vue&type=template&id=0f4b0932"
import script from "./Partner.vue?vue&type=script&lang=js"
export * from "./Partner.vue?vue&type=script&lang=js"
script.render = render

export default script